// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__K6smp","image":"Header_image__1EHJd","name":"Header_name__1VelG","info":"Header_info__1kAeq","infoRow":"Header_infoRow__NmcKG"};